import { Layout } from '../../components/Layout';

export const Dashboard = () => {
    return <Layout></Layout>;
};
